import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { closeFeedBack } from "../../redux/features/examDetails/examDetailsSlice";

const FeedBackModal = () => {
  const dispatch = useDispatch();
  const showFeedBack = useSelector((state) => state.examDetail.showFeedBack);
  console.log({ showFeedBack });
  return (
    <>
      <Modal
        show={showFeedBack}
        // show={show}
        // onHide={handleClose}
        animation={true}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body>
          <div className="d-flex flex-column align-items-center px-5 py-4 text-center">
            <h4 className="text-center mb-4">
              Your exam has been submitted successfully.{" "}
            </h4>
            <p className="text-info px-3 mb-4">
              Kindly spare us few minutes to complete this form link{" "}
              <a
                href="https://forms.gle/4EVAxBZi4pTcCmyR7"
                rel="noreferrer"
                target="_blank"
              >
                (https://forms.gle/4EVAxBZi4pTcCmyR7)
              </a>
            </p>
            <Button
              onClick={() => {
                dispatch(closeFeedBack());
              }}
            >
              {" Close "}
            </Button>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button className="mx-auto calculator-btn" onClick={() => {}}>
            Start Exam
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};

export default FeedBackModal;
